export function deepClone(input) {
  let output, value, key;

  if (typeof input !== "object" || input === null) {
    return input; // Return the value if input is not an object
  }

  // Create an array or object to hold the values
  output = Array.isArray(input) ? [] : {};

  for (key in input) {
    value = input[key];

    // Recursively (deep) copy for nested objects, including arrays
    output[key] = deepClone(value);
  }

  return output;
}
